const GraphQLQuery = require('app/graphql/Query');
const ExportModal = require('app/order/analyse/ExportModal')

class IndexView {
    defaultOptions() {
        return {
            'selector': '.view-order-analyse',
            'tableContainerSelector': '.order-analyse-container',
            'filterFormSelector': '.order-analyse-search-form',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.onClickExport = this.onClickExport.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$filterForm =  $(this.settings.filterFormSelector,this.$container);
        this.$btnExport = $('.btn-export',this.$container);
        
        this.$unsetContainer = $('.order-analyse-unset',this.$tableContainer);
        this.$resultContainer = $('.order-analyse-result',this.$tableContainer);

        this.initialize();
    }

    initialize() {
        var self = this;
        
        this.initializeFilterForm();


        this.$btnExport.on('click',this.onClickExport);
    }

    initializeFilterForm(){
        var self = this;

        this.$filterBySuppliers = $('select[id="suppliers"]',this.$filterForm);
        this.$filterByRestaurant = $('select[name="restaurant"]',this.$filterForm);
        this.$filterByRange = $('select[name="range"]',this.$filterForm);
        this.$filterByNumber = $('input[name="number"]',this.$filterForm);
        this.$filterFrom = $('input[name="from"]',this.$filterForm);
        this.$filterTo = $('input[name="to"]',this.$filterForm);

        window.select2(
            this.$filterBySuppliers,
            {
                'placeholder': 'Sélection de fournisseurs',
                'allowClear': true,
                'closeOnSelect': false,
            }
        );
        window.select2(
            this.$filterByRestaurant,
            {
                'placeholder': 'Sélection du restaurant',
            }
        );

        this.$filterForm.on('submit',this.onSubmitFilterForm);

    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.loadData();
    }

    refresh(){
        this.loadData();
    }

    isAnalysable(){
        let suppliers = this.$filterBySuppliers.val();
        let from = this.$filterFrom.val();
        let to = this.$filterTo.val();


        if(suppliers.length == 0 && from == '' && to == ''){
            return false;
        }

        return true;
    }

    loadData(){
        this.$unsetContainer.show();
        this.$btnExport.attr('disabled','disabled');


        if(this.isAnalysable()){
            this.$unsetContainer.hide();
            this.$resultContainer.show();

            let query = this.buildQuery();
            query.execute();
        }
        
    }

    buildQuery(){
        var self = this;

        
        let parameters = {
            'suppliers': this.$filterBySuppliers.val(),
            'from': this.$filterFrom.val(),
            'to': this.$filterTo.val(),
        };
        
        let restaurant = this.$filterByRestaurant.val();
        if(restaurant){
            parameters['restaurant'] = restaurant;
        }

        let range = this.$filterByRange.val();
        if(range){
            parameters['range'] = parseInt(range);
        }
        let number = this.$filterByNumber.val();
        if(number){
            parameters['number'] = number;
        }

        let fields = [
            'type',
            'product { id number reference unit }',
            'quantity',
            'totalSupplier',
            'ht',
            'ttc',
            'margin',
            'marginPercent',
        ];

        return new GraphQLQuery({
            //parameters
            'queryType': 'restaurantOrderAnalyse',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,

            //callbacks
            'before': function(){
                self.$resultContainer
                .html('')
                .append(window.App.generateLoader(true));
            },
            'success': function(data){
                self.drawAnalyse(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
                self.$btnExport.removeAttr('disabled');
            }
        });

    }

    drawAnalyse(data){
        
        let $table = $('<table/>')
        .addClass('table table-striped table-bordered table-condensed table-responsive');

        let $tbody = $('<tbody/>');
        let $thead = $('<thead/>');
        let $tfoot = $('<tfoot/>');

        let $headerRow = $('<tr/>')
        .append(
            $('<th/>')
            .append('#')
        )
        .append(
            $('<th/>')
            .append('Produit')
        )
        .append(
            $('<th/>')
            .addClass('text-end')
            .append('Quantités')
        )
        .append(
            $('<th/>')
            .addClass('text-end')
            .append('Total achat')
        )
        .append(
            $('<th/>')
            .addClass('text-end')
            .append('Total vente')
        )
        .append(
            $('<th/>')
            .addClass('text-end')
            .append('TTC')
        )
        .append(
            $('<th/>')
            .addClass('text-end')
            .append('Marge')
        )
        .append(
            $('<th/>')
            .addClass('text-end')
            .append('% Marge')
        );

        $thead.append($headerRow);

        for(let line of data){
            let type = line.type;
            let $row = $('<tr/>');
            switch(type){
                case 'product':
                    if(line.ht > 0){
                        let product = line.product;
                        $row
                        .append(
                            $('<td/>')
                            .append(product.number)
                        )
                        .append(
                            $('<td/>')
                            .append(product.reference)
                        )
                        .append(
                            $('<td/>')
                            .addClass('text-end')
                            .append(window.formatFloat(line.quantity)+ " "+product.unit)
                        )
                        .append(
                            $('<td/>')
                            .addClass('text-end')
                            .append(window.formatFloat(line.totalSupplier)+ " &euro;")
                        )
                        .append(
                            $('<td/>')
                            .addClass('text-end')
                            .append(window.formatFloat(line.ht)+ " &euro;")
                        )
                        .append(
                            $('<td/>')
                            .addClass('text-end')
                            .append(window.formatFloat(line.ttc)+ " &euro;")
                        )
                        .append(
                            $('<td/>')
                            .addClass('text-end')
                            .append(window.formatFloat(line.margin)+ " &euro;")
                        )
                        .append(
                            $('<td/>')
                            .addClass('text-end')
                            .append(window.formatFloat(line.marginPercent)+ "%")
                        )
                        $tbody.append($row);
                    }
                break;

                case 'total':
                    $row
                    .append(
                        $('<td/>')
                        .attr('colspan',3)
                        .addClass('text-end')
                        .addClass('text-bold')
                        .append("Totaux")
                    )
                    .append(
                        $('<td/>')
                        .addClass('text-end')
                        .addClass('text-bold')
                        .append(window.formatFloat(line.totalSupplier)+ " &euro;")
                    )
                    .append(
                        $('<td/>')
                        .addClass('text-end')
                        .addClass('text-bold')
                        .append(window.formatFloat(line.ht)+ " &euro;")
                    )
                    .append(
                        $('<td/>')
                        .addClass('text-end')
                        .addClass('text-bold')
                        .append(window.formatFloat(line.ttc)+ " &euro;")
                    )
                    .append(
                        $('<td/>')
                        .addClass('text-end')
                        .addClass('text-bold')
                        .append(window.formatFloat(line.margin)+ " &euro;")
                    )
                    .append(
                        $('<td/>')
                        .addClass('text-end')
                        .addClass('text-bold')
                        .append(window.formatFloat(line.marginPercent)+ "%")
                    )

                    $tfoot.append($row);
                break;
            }
        }
        
        $table
        .append($thead)
        .append($tbody)
        .append($tfoot);

        this.$resultContainer
        .html('')
        .append($table);
    }

    onClickExport(event){
        event.preventDefault();
        event.stopPropagation();
        
        let parameters = {
            'suppliers': this.$filterBySuppliers.val(),
            'from': this.$filterFrom.val(),
            'to': this.$filterTo.val(),
        };
        
        let restaurant = this.$filterByRestaurant.val();
        if(restaurant){
            parameters['restaurant'] = restaurant;
        }

        let range = this.$filterByRange.val();
        if(range){
            parameters['range'] = parseInt(range);
        }
        let number = this.$filterByNumber.val();
        if(number){
            parameters['number'] = number;
        }


        new ExportModal({
            'parameters': parameters
        });
    }

}

module.exports = IndexView;